const trasnlations = {
  en: {
    greatings: 'Hi! I am Felipe Rodrigues',
    carrer: 'Full Stack Engineer',
    tagline:
      'I work on APIs, integrations, and front ends that actually ship: tests in the loop, CI that people trust, and enough logging to fix production without guessing.',
    button: 'Download resume',
  },
  pt: {
    greatings: 'Olá! Eu sou Felipe Rodrigues',
    carrer: 'Engenheiro Full Stack',
    tagline:
      'Trabalho com APIs, integrações e front que vão para produção: teste no fluxo, pipeline que a equipe confia e log suficiente para achar bug sem chute.',
    button: 'Baixar currículo',
  },
};

export default trasnlations;
